// extracted by mini-css-extract-plugin
export var childrenContainer = "_d5-0";
export var virtualScrollArea = "_d5-1";